import { render, staticRenderFns } from "./HeaderNoticePanel.vue?vue&type=template&id=3485d785&scoped=true"
import script from "./HeaderNoticePanel.vue?vue&type=script&lang=js"
export * from "./HeaderNoticePanel.vue?vue&type=script&lang=js"
import style0 from "./HeaderNoticePanel.vue?vue&type=style&index=0&id=3485d785&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3485d785",
  null
  
)

export default component.exports